import Notifications from './Notifications';
import React, { useEffect, useState } from 'react';
import "./Organization.css";
import ManageOrgMembersSection from '../components/SettingsComponents/ManageOrgMembersSection';
import { logEvent } from '../utils/logger';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PageHeader, Skeleton } from '../components/ui/Primitives';
import { memberProfileFromResponse } from '../utils/sessionData';
import MessageDeliverySettings from '../components/SettingsComponents/MessageDeliverySettings';

const ORGANIZATION_TABS = [
  { id: 'team', label: 'Team & routing' },
  { id: 'messages', label: 'Message access' },
  { id: 'reports', label: 'Call reports' },
];

function Organization({ checkLogin, organization, orgMember }) {
  const [updatedOrgMember, setUpdatedOrgMember] = useState(orgMember);
  const [isLoading, setIsLoading] = useState(true);
  const [reportVersion, setReportVersion] = useState(0);
  const [teamVersion, setTeamVersion] = useState(0);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const activeTab = searchParams.get('invite') === '1' ? 'team'
    : ORGANIZATION_TABS.some(tab => tab.id === requestedTab) ? requestedTab : 'team';
  const selectTab = id => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next);
  };
  const navigateTabs = event => {
    const current = ORGANIZATION_TABS.findIndex(tab => tab.id === activeTab);
    const next = event.key === 'ArrowRight' ? (current + 1) % 3
      : event.key === 'ArrowLeft' ? (current + 2) % 3
      : event.key === 'Home' ? 0 : event.key === 'End' ? 2 : null;
    if (next === null) return;
    event.preventDefault();
    const id = ORGANIZATION_TABS[next].id;
    selectTab(id);
    document.getElementById(`organization-tab-${id}`)?.focus();
  };

  // <-- NEW: notify chat widget
  useEffect(() => {
    if (!isLoading && updatedOrgMember) {
      const iframe = document.getElementById('chat-iframe');
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage({ type: 'page.navigation', page: 'Organization' }, '*');
      }
    }
  }, [isLoading, updatedOrgMember]);

  useEffect(() => {
    async function fetchUserData() {

      setIsLoading(true);
      try {
        const jwt_token = localStorage.getItem('jwt_authorization');
        if (!jwt_token) {
          navigate('/');
          return;
        }
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/user`, { jwt_token });
        if (response.status === 200) {
          setUpdatedOrgMember(memberProfileFromResponse(response.data));
          setIsLoading(false);
        }
      } catch (err) {
        if (err.response?.status === 401) {
          localStorage.removeItem('jwt_authorization');
          navigate('/');
        }
        setIsLoading(false);
      }
    }
    fetchUserData();

    logEvent({
      event: {
        label: 'PageView',
        data: { page: 'Organization', user_id: orgMember ? orgMember.id : null }
      }
    });
  }, [navigate, orgMember]);

  if (!isLoading && updatedOrgMember) {
    return (
      <div className="page-content organization-page">
        <PageHeader eyebrow="Workspace settings" title="Organization" description="Manage your team, message access, and call reports." />
        <div className="organization-tabs" role="tablist" aria-label="Organization settings" onKeyDown={navigateTabs}>
          {ORGANIZATION_TABS.map(tab => (
            <button key={tab.id} type="button" role="tab" id={`organization-tab-${tab.id}`}
              aria-selected={activeTab === tab.id} aria-controls={`organization-panel-${tab.id}`}
              tabIndex={activeTab === tab.id ? 0 : -1} onClick={() => selectTab(tab.id)}>
              {tab.label}
            </button>
          ))}
        </div>
        <section className="organization-panel" role="tabpanel" id="organization-panel-team" aria-labelledby="organization-tab-team" hidden={activeTab !== 'team'}>
          <ManageOrgMembersSection orgMember={updatedOrgMember} initialOrganization={organization}
            refreshVersion={teamVersion} onMemberSaved={() => setReportVersion(value => value + 1)} />
        </section>
        <section className="organization-panel" role="tabpanel" id="organization-panel-messages" aria-labelledby="organization-tab-messages" hidden={activeTab !== 'messages'}>
          <h2>Who should receive general messages?</h2>
          <MessageDeliverySettings compact orgMember={updatedOrgMember} refreshVersion={reportVersion} />
        </section>
        <section className="organization-panel" role="tabpanel" id="organization-panel-reports" aria-labelledby="organization-tab-reports" hidden={activeTab !== 'reports'}>
          <Notifications orgMember={updatedOrgMember} embedded refreshVersion={reportVersion} onSaved={() => setTeamVersion(value => value + 1)} />
        </section>
      </div>
    );
  } else {
    return <div className="page-content organization-page"><Skeleton width="40%" height={42} /><Skeleton height={300} /></div>;
  }
}

export default Organization;
